module.exports = __webpack_public_path__ + "img/photo2_2.2affd6ce.jpg";